//
// Lozad
//

import lozad from 'lozad';

// Init lozad(Lazyload)
const observer = lozad();
observer.observe();